<script setup>
import { useBiStore } from '~/bi/store/bi.store';

const bi_store = useBiStore();

const html_url = computed(() => bi_store.selected_dashboard_details?.widgets?.content?.html_url || '');

const state = reactive({
  html_content: '',
  is_loading: false,
});

watch(html_url, async (url) => {
  if (!url) {
    state.html_content = '';
    return;
  }
  try {
    state.is_loading = true;
    const response = await fetch(url);
    let html = await response.text();

    // NOTE: The following patches are applied to the HTML content to fix issues with the dashboard rendering in an iframe. The first patch fixes a bug in the CanvasRenderingContext2D.arc method that causes negative radius values to be treated as 0, which can lead to rendering issues. The second patch triggers a resize event after the page has loaded to ensure that the dashboard is rendered correctly. These were added to fix some issues with real client dashboards that were not rendering correctly in the iframe.
    const arc_patch = `<script>(function(){var _a=CanvasRenderingContext2D.prototype.arc;CanvasRenderingContext2D.prototype.arc=function(x,y,r,sA,eA,ccw){_a.call(this,x,y,r<0?0:r,sA,eA,ccw);};})();<\/script>`;
    const resize_script = `<script>window.addEventListener('load',function(){setTimeout(function(){window.dispatchEvent(new Event('resize'));},100);});<\/script>`;
    html = html.includes('<head>')
      ? html.replace('<head>', `<head>${arc_patch}`)
      : arc_patch + html;
    html = html.includes('</body>')
      ? html.replace('</body>', `${resize_script}</body>`)
      : html + resize_script;

    state.html_content = html;
  }
  catch {
    state.html_content = '';
  }
  finally {
    state.is_loading = false;
  }
}, { immediate: true });
</script>

<template>
  <!-- RIL wanted BI to have dashboards that accepted HTML so they could create their own custom dashboards and see them. However, HTML files are not usually accepted for security purposes. But we won't be able to loosen up the CSP policy as it would open up the floodgates for everything. -->
  <!-- Therefore, if issues are reported in RIL environment, check if they work fine on local/dev. If they do, it is an issue with security. Find an alternative, either by making the HTML safer or checking the CSP -->
  <HawkLoader v-if="state.is_loading" container_class="bg-gray-50 min-h-[calc(100vh-167px)]" />
  <iframe
    v-else
    class="w-full border-0 block min-h-[calc(100vh-167px)]"
    sandbox="allow-scripts"
    referrerpolicy="no-referrer"
    allow=""
    :srcdoc="state.html_content"
  />
</template>
